<main class="donner-page">
  <section class="donner-hero">
    <div class="container">
      <h1>{{ 'pages.shared.donner.donner.text001' | translate }}</h1>
      <p class="subtitle">{{ 'pages.shared.donner.donner.extra001' | translate }}</p>
    </div>
  </section>

  <section class="donner-intro">
    <div class="container">
      <div class="intro-card">
        <h2>{{ 'pages.shared.donner.donner.text002' | translate }}</h2>
        <p>{{ 'pages.shared.donner.donner.text003' | translate }}</p>
      </div>
    </div>
  </section>

  <section class="donner-form-section">
    <div class="container">
      <div class="helloasso-container">
        @if (!iframeLoaded() && !iframeError()) {
          <div class="helloasso-loading">Chargement du formulaire sécurisé HelloAsso…</div>
        }
        <iframe
          title="Formulaire de don AGBE sur HelloAsso"
          allowtransparency="true"
          scrolling="yes"
          src="https://www.helloasso.com/associations/agbe/formulaires/14/widget"
          (load)="iframeLoaded.set(true)"
          (error)="iframeError.set(true)"
          loading="eager"
          referrerpolicy="strict-origin-when-cross-origin">
        </iframe>
        <p class="helloasso-fallback">
          En cas de problème d'affichage, <a [href]="donationUrl" target="_blank" rel="noopener noreferrer">ouvrir le formulaire HelloAsso</a>.
        </p>
      </div>
    </div>
  </section>
</main>
